import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const requiresAuth = route.data['requiresAuth'] !== false;
  const hasToken = authService.isLoggedIn();
  const tokenExpired = authService.isTokenExpired();

  // An expired token is purged on every route, not just auth-required ones.
  // Otherwise the cookie/signal stay populated on /login and the layout
  // ends up showing a logout button on the login screen.
  if (hasToken && tokenExpired) {
    authService.logout();
    return false;
  }

  const effectivelyLoggedIn = hasToken && !tokenExpired;

  if (requiresAuth && !effectivelyLoggedIn) {
    router.navigate(['/login']);
    return false;
  }

  if (!requiresAuth && effectivelyLoggedIn) {
    router.navigate(['/licenses']);
    return false;
  }

  return true;
};
